import { Component, ElementRef, OnInit, ViewChild, Inject, PLATFORM_ID, OnDestroy, } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EditorialService } from '../services/editorial.service';
import { ActivatedRoute } from '@angular/router';
import { editorialListResponseData, editorsList } from 'src/interface/editorial-board';
import { EnvService } from '../services/env.service';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ViewEditorDetailsComponent } from './view-editor-details/view-editor-details.component';
import { JournalService } from '../journal/journal.service';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SharedService } from '../services/shared.service';

@Component({
  selector: 'app-editorial-board',
  templateUrl: './editorial-board.component.html',
  styleUrls: ['./editorial-board.component.scss']
})
export class EditorialBoardComponent implements OnInit, OnDestroy {
  @ViewChild('textElement') textElement: ElementRef<HTMLDivElement>;

  journalid: string;
  editorsImageUrl: string;
  editorsDetails: editorialListResponseData[] = [];
  i: number;
  modalclose = '';
  editorsDetailsLength: number;
  containerHeight = 0;
  loading = true;
  editorial_loader = new Array(4).fill(0);
  subscriptionArr: Subscription[] = [];
  constructor(public editorialService: EditorialService, private router: ActivatedRoute,
    private EnvService: EnvService, private modalservice: NgbModal, private elementRef: ElementRef,
    private journalService: JournalService, private titleService: Title, private translate: TranslateService,
    private metatag: Meta,private sharedService:SharedService,
    @Inject(PLATFORM_ID) private platformId: any) {
  }
  ngOnInit(): void {
    this.metatag.updateTag(
      { property: 'og:url', content: this.EnvService.siteUrl + this.router.snapshot.url[0].path },
    );
    setTimeout(() => {
      this.calculateContainerHeight();
    });
    const journalsubs = this.router.params.subscribe(params => {
      this.journalid = params['journal_id'];
    });
    this.subscriptionArr.push(journalsubs);
    const journalType = { jnl_type: "JNL" }
    if (this.journalid == undefined)

      this.journalService.getJournals(journalType).subscribe((result) => {
        this.journalid = result.data[0].id;
        this.translate.get('journal_home.Editorial_heading').subscribe((translation: string) => {
          const page_heading = translation;
          this.titleService.setTitle(page_heading + ' | ' + result.data[0].journal_display_name);
          this.metatag.updateTag(
            { property: 'og:type', content: 'Content' },
          );
          this.metatag.updateTag(
            { property: 'og:title', content: page_heading },
          );
          // this.metatag.updateTag(
          //   { property: 'og:description', content: "Editorial board members" },
          // );
          // this.metatag.updateTag(
          //   { property: 'og:image', content: this.EnvService.imageUrl + 'themes/' + result.data[0].journal_cover_image },
          // );
        });
        const journalId = { 'journal_id': this.journalid }
        const getallsubs = this.editorialService.getAllEditorialMembers(journalId).subscribe((response) => {
          this.loading = false;
          this.editorsDetails = response.data;
          //    this.editorsDetails.push(response)
          this.editorsDetailsLength = this.editorsDetails.length

        })
        this.subscriptionArr.push(getallsubs);
        this.editorsImageUrl = this.EnvService.editorialImage;
        //   this.editorialService.getEditorialMembers()
        // }
        // constructor(public editorialService:EditorialService){

      });
      const url= this.router.params.subscribe(params => {
        this.sharedService.setUrlParams(params);
    });
    this.subscriptionArr.push(url);
  }

  getDetails(editorDetails: editorsList) {
    const modal: NgbModalRef = this.modalservice.open(ViewEditorDetailsComponent, { ariaLabelledBy: 'modal-content', size: 'xl' })
    modal.result.then((res) => {
      this.modalclose = `Closed with: ${res}`;
    }, (res) => {
      this.modalclose = `Dismissed ${this.getDismissReason(res)}`;
    });
    modal.componentInstance.details = editorDetails;
  }
  // chunkArray(array: editorsList[], chunkSize: number): editorsList[][] {
  //   const chunks: editorsList[][] = [];
  //   for (let i = 0; i < array.length; i += chunkSize) {
  //     if (i == 7) {
  //       break;
  //     }
  //     else chunks.push(array.slice(i, i + chunkSize));
  //   }
  //   return chunks;
  // }
  private getDismissReason(reason): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  calculateContainerHeight(): void {
    if (isPlatformBrowser(this.platformId)) {
      const headerHeight = this.getHeaderHeight();
      const footerHeight = this.getFooterHeight();
      this.containerHeight = window.innerHeight - (headerHeight + footerHeight);
    }
  }

  getHeaderHeight(): number {
    const headerElement = this.elementRef.nativeElement.querySelector('.header');
    return headerElement ? headerElement.offsetHeight : 0;
  }

  getFooterHeight(): number {
    const footerElement = this.elementRef.nativeElement.querySelector('.footer');
    return footerElement ? footerElement.offsetHeight : 0;
  }

  openOrcidLink(orcid: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.open('https://orcid.org/' + orcid, 'Orcid Link', 'resizeable,height=800,width=600');
    }
  }

  ensureHttps(url: string): string {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }
  checkignForEndRow(): boolean {
    return true;
  }
  public destroyMetaTagsforSEONew() {
    this.metatag.updateTag(
      { property: 'og:url', content: this.EnvService.siteUrl },
    );
    this.metatag.updateTag(
      { property: 'og:title', content: "Journal of the British Academy" },
    );
    this.metatag.updateTag(
      { property: 'og:description', content: "Journal of the British Academy" },
    );
    // this.metatag.updateTag(
    //   { property: 'og:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
    // );
  }

  ngOnDestroy() {
    this.destroyMetaTagsforSEONew();
    this.subscriptionArr.forEach(x => {
      if (!x.closed) {
        x.unsubscribe();
      }
    });
  }
  checkProfesor(data: string) {
    return data.includes('Professor') ? 'PROFESSOR' : '';
    
  }
  checkName(data: string) {
    return data.replace('Professor', '').trim().toUpperCase();
 
  }
}
